import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import classnames from 'classnames';
import T from 'i18n';

const FilterCases = ({ value = '', onSearchChange }) => {
  const [searchVal, setSearchVal] = useState(value);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    setSearchVal(value);
  }, [value]);

  const handleSearchVal = (val) => {
    setSearchVal(val);
    onSearchChange(val);
  };

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
      }}
      className="search-cases"
    >
      <div className={classnames('search-container search-box-size', { focused: focused })}>
        <FormControl
          type="search"
          placeholder={T.translate('home.searchCasesMsg')}
          className="mr-sm-2"
          value={searchVal}
          onChange={({ target: { value } }) => handleSearchVal(value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearchVal(e.target.value);
              e.stopPropagation();
              e.preventDefault();
            }
          }}
          autoFocus
        />
      </div>
    </Form>
  );
};

FilterCases.propTypes = {
  value: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
};

FilterCases.defaultProps = {
  value: '',
};

export default FilterCases;
